import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  getContactName,
  getGroupLogotype,
} from "@vocollege/app/dist/modules/VoHelpers";
import { GeneralObject } from "@vocollege/app/dist/global";
import { convertSvgToImage } from "@vocollege/app/dist/modules/VoHelpers";
import LogoPlaceholder from "../components/LogoPlaceholder/LogoPlaceholder";

const AmbassadorCertificateTemplate: React.FC<TemplateProps> = (props) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);

  // Methods.

  const setImage = async () => {
    let output: GeneralObject[] = [];
    try {
      getGroupLogotype(item.college, "logo", output);
      if (output.length > 0) {
        let convertedImage = await convertSvgToImage(output[0].url, 300);
        setLogotype(convertedImage);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Effects.

  useEffect(() => {
    if (item) {
      setImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    //@ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={[baseStyles.page, styles.page]} wrap={false}>
        <View style={styles.decor}>
          <View style={styles.logoWrapper}>
            {logotype && (
              <ReactPdfImage
                src={logotype}
                style={[baseStyles.logo, styles.logo]}
              />
            )}
            {!logotype && <LogoPlaceholder />}
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.title}>
              {I18n.get.ambassadorCertificate.template.title}
            </Text>
            <Text style={styles.subtitle}>
              {I18n.get.ambassadorCertificate.template.subtitle}
            </Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
          </View>

          <View style={baseStyles.section}>
            <Text style={styles.text}>
              {I18n.get.ambassadorCertificate.template.text1}
            </Text>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text1a}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text1b}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text1c}
              </Text>
            </View>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.text}>
              {I18n.get.ambassadorCertificate.template.text2}
            </Text>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2a}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2b}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2c}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2d}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2e}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2f}
              </Text>
            </View>
            <View style={styles.listItem}>
              <Text style={styles.listItemIcon}>&#x2022;</Text>
              <Text style={[styles.text, styles.listItemText]}>
                {I18n.get.ambassadorCertificate.template.text2g}
              </Text>
            </View>
          </View>

          <View style={baseStyles.grow}></View>

          <View style={[baseStyles.section, styles.footer]}>
            {item && (
              <>
                <View style={styles.college}>
                  {item.college && (
                    <Text style={styles.collegeTitle}>
                      {item.college.title}
                    </Text>
                  )}
                  <Text style={styles.date}>{item.date}</Text>
                </View>

                {item.responsible && item.responsible !== "" && (
                  <View style={styles.signatures}>
                    <View style={styles.signature}>
                      <Text style={styles.signaturePerson}>
                        {item.responsible}
                      </Text>
                      <Text style={styles.signatureTitle}>
                        {I18n.get.ambassadorCertificate.template.responsible}
                      </Text>
                    </View>
                  </View>
                )}
              </>
            )}
          </View>
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default AmbassadorCertificateTemplate;
